import { api, endpoints } from "../utils/axiosInstance";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const authService = {
  login: async (email, password) => {
    try {
      console.log("authService: Đang gửi yêu cầu đăng nhập...");
      const response = await api.post(endpoints.auth.login, {
        email,
        password,
      });
      console.log("authService: Phản hồi từ API đăng nhập:", response);
      if (response && response.accessToken) { // Đảm bảo kiểm tra response và accessToken
        sessionStorage.setItem("token", response.accessToken);
        console.log("authService: Đã lưu token vào sessionStorage.");
      } else {
        console.warn("authService: Phản hồi đăng nhập không chứa accessToken.");
      }
      return response;
    } catch (error) {
      console.error("authService: Lỗi trong quá trình đăng nhập:", error);
      throw error;
    }
  },

  register: async (userData) => {
    try {
      const response = await api.post(endpoints.auth.register, userData);
      if (response.accessToken) {
        sessionStorage.setItem("token", response.accessToken);
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  logout: async () => {
    try {
      await api.post(endpoints.auth.logout);
      sessionStorage.removeItem("token");
    } catch (error) {
      sessionStorage.removeItem("token");
      throw error;
    }
  },

  googleLogin: () => {
    const callbackUrl = `${window.location.origin}/login-success`;
    window.location.href = `${API_URL}/auth/google?callback_url=${encodeURIComponent(
      callbackUrl
    )}`;
  },

  handleGoogleCallback: async (token) => {
    try {
      if (!token) throw new Error("No token provided");
      sessionStorage.setItem("token", token);

      const res = await api.get(endpoints.user.profile, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const response = res.data?.user || res.data || res;


      return {
        _id: response._id,
        full_name: response.full_name,
        email: response.email,
        phone: response.phone,
        role: response.role,
        authProvider: response.authProvider,
        profile_picture: response.profile_picture,
        gender: response.gender,
        date_of_birth: response.date_of_birth,
        job: response.job,
        height: response.height,
        weight: response.weight,
        calorieGoal: response.calorieGoal,
        proteinGoal: response.proteinGoal,
        fatGoal: response.fatGoal,
        carbGoal: response.carbGoal,
        notificationSettings: response.notificationSettings,
        lastNotificationSent: {
          breakfast: response.lastNotificationSent?.breakfast
            ? new Date(response.lastNotificationSent.breakfast)
            : null,
          lunch: response.lastNotificationSent?.lunch
            ? new Date(response.lastNotificationSent.lunch)
            : null,
          dinner: response.lastNotificationSent?.dinner
            ? new Date(response.lastNotificationSent.dinner)
            : null,
          snack: response.lastNotificationSent?.snack
            ? new Date(response.lastNotificationSent.snack)
            : null,
          general: response.lastNotificationSent?.general
            ? new Date(response.lastNotificationSent.general)
            : null,
        },
      };
    } catch (error) {
      console.error("❌ Error in handleGoogleCallback (authService):", error);
      sessionStorage.removeItem("token");
      throw error;
    }
  },

  getCurrentUser: async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return null;

      const res = await api.get(endpoints.user.profile, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const response = res.data?.user || res.data || res;


      return {
        _id: response._id,
        full_name: response.full_name,
        email: response.email,
        phone: response.phone,
        role: response.role,
        authProvider: response.authProvider,
        profile_picture: response.profile_picture,
        gender: response.gender,
        date_of_birth: response.date_of_birth,
        job: response.job,
        height: response.height,
        weight: response.weight,
        calorieGoal: response.calorieGoal,
        proteinGoal: response.proteinGoal,
        fatGoal: response.fatGoal,
        carbGoal: response.carbGoal,
        notificationSettings: response.notificationSettings,
        lastNotificationSent: {
          breakfast: response.lastNotificationSent?.breakfast
            ? new Date(response.lastNotificationSent.breakfast)
            : null,
          lunch: response.lastNotificationSent?.lunch
            ? new Date(response.lastNotificationSent.lunch)
            : null,
          dinner: response.lastNotificationSent?.dinner
            ? new Date(response.lastNotificationSent.dinner)
            : null,
          snack: response.lastNotificationSent?.snack
            ? new Date(response.lastNotificationSent.snack)
            : null,
          general: response.lastNotificationSent?.general
            ? new Date(response.lastNotificationSent.general)
            : null,
        },
        healthGoal: response.healthGoal,
        activityLevel: response.activityLevel,
        dietaryPreferences: response.dietaryPreferences,
        allergies: response.allergies,
        otherAllergies: response.otherAllergies,
        healthConditions: response.healthConditions,
        otherHealthConditions: response.otherHealthConditions,
        mealCountPerDay: response.mealCountPerDay,
        preferredMealTimes: response.preferredMealTimes,
      };
    } catch (error) {
      console.error("❌ Error in getCurrentUser (authService):", error);
      sessionStorage.removeItem("token");
      return null;
    }
  },

  isLoggedIn: () => {
    return !!sessionStorage.getItem("token");
  },
};